import React from 'react';
import { useHistory } from 'react-router-dom';
import { SectionWrapper, Heading, Title, EditIcon, EditField, EditText } from './Section.styles';
import { trackViewedPage } from '../../../../utilities';

type OwnProps = React.PropsWithChildren<{
  editPageUrl?: string;
  shouldShowEditIcon?: boolean;
  title: string;
}>;

function Section({ shouldShowEditIcon = true, title, children, editPageUrl }: OwnProps) {
  const history = useHistory();

  const navigateToEditPage = () => {
    if (!editPageUrl) return;

    history.push(editPageUrl);
    trackViewedPage(editPageUrl);
  };

  return (
    <SectionWrapper>
      <Heading>
        <Title>{title}</Title>
        {shouldShowEditIcon && (
          <EditField onClick={() => navigateToEditPage()}>
            <EditIcon />
            <EditText>EDIT</EditText>
          </EditField>
        )}
      </Heading>
      {children}
    </SectionWrapper>
  );
}

export default Section;
